export default "https://cdn-static.gokick.com/assets/78cedee4a9b459fbef408ae219aa3203e6c5e731/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";